// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/icon-template/src/index.tsx

import baseIcon, { defaultIconGroupProps } from '@bubble-ui/temp-icon-base';
var IconSavingFixedPath = 'M17 3.25h-1.273v1.57l1.186 1.606A3 3 0 0 1 17.5 8.21v7.541a3 3 0 0 1-3 3h-9a3 3 0 0 1-3-3V8.209a3 3 0 0 1 .587-1.783l1.186-1.605V3.25H3v-2h14v2Zm-10.727 0h7.454v2.23l1.577 2.134a1 1 0 0 1 .196.595v7.541a1 1 0 0 1-1 1h-.585a2.75 2.75 0 0 0-1.484-4.665 2.75 2.75 0 1 0-4.834.05 2.751 2.751 0 0 0-1.25 4.615H5.5a1 1 0 0 1-1-1V8.209a1 1 0 0 1 .196-.595L6.273 5.48V3.25Zm1.262 11.548a.75.75 0 1 1 1.5 0 .75.75 0 0 1-1.5 0Zm4.442-.75a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5Zm-2.727-3.25a.75.75 0 1 1 1.5 0 .75.75 0 0 1-1.5 0Z';
var IconSavingFixed = baseIcon('IconSavingFixed', {
  groupProps: defaultIconGroupProps,
  getPath: () => IconSavingFixedPath
});
export default IconSavingFixed;
//# sourceMappingURL=index.js.map